import { gql } from '@apollo/client'

export const SET_CUSTOMER_ADDRESS_AS_PRIMARY = gql`
  mutation SetCustomerAddressAsPrimary($input: SetCustomerAddressAsPrimaryInput!) {
    setAsPrimaryCustomerAddress(input: $input) {
      customerAddress {
        id
      }
    }
  }
`
